import PublishTabs from './PublishTabs';

export default PublishTabs;
